import React, { useState } from "react";
import { Alert, Col, Row, Spin } from "antd";

const ReportingAnalysis = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const handleIframeLoad = () => {
    setIsLoading(false);
  };

  return (
    <>
      <Row className="mt-5">
        <Col className="gutter-row" span={24}>
          {isLoading && (
            <div
              style={{
                position: "absolute",
                // top: "50%",
                marginTop: "10%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1,
              }}
            >
              <Spin tip="Loading...">
                <Alert
                  message="Please be patient while loading report"
                  description="This might take few seconds. Thank you"
                  type="info"
                />
              </Spin>
              {/* You can replace the button with a spinner or any other loading indicator */}
            </div>
          )}
          <iframe
            src="https://dash.nibblesbakery.ng/"
            title="Embedded Report"
            onLoad={handleIframeLoad}
            style={{
              width: "100%",
              height: 800,
              border: "none",
              overflow: "hidden",
              display: isLoading ? "none" : "block",
            }}
          />
        </Col>
      </Row>
    </>
  );
};
export default ReportingAnalysis;
